<template>
    <header class="dashHeader">
        <h1 class="dashTitle">
            {{leaseNum}}
        </h1>
    </header>
</template>

<script>
export default {
    name: 'lease-header',
    data: () => ({
        leaseNum: "Lease"
    }),
    methods: {
        updateInfo: function(leaseNum) {
            var globv = this;
            if (leaseNum) {
                globv.leaseNum = leaseNum;
            }
        },
        reset: function() {
            var globv = this;
            globv.leaseNum = "Lease"
        }
    }
}
</script>

<style lang="scss">
.dashHeader {
    display: flex;
    justify-content: center;
    padding: 10px;
    background-color: #2f55a4;
    color: white;
    background-color: var(--primaryColor);
    color: var(--primaryTextColor);
    height: fit-content;
}

.dashTitle {
    font-size: 2rem;
}
</style>